<template>
  <!-- 下订单模块 -->
  <div class="shelves-right-wrap">
    <div class="operation" style="position:relative">
      <el-row>
        <div v-if="dislayFlag" style="font-size:14px;margin-top:6px;color:#494949">
          采购车导入的待支付订单有
          <span style="color:#f7ba2a;font-weight:600">{{ totalDetailNum }}</span>个商品，形成
          <span style="color:#f7ba2a;font-weight:600">{{ totalInfoNum }}</span>个订单
        </div>
      </el-row>
      <el-row>
        <div v-if="dislayFlag" style="font-size:14px;color:#494949">
          订单已占用库存，随创建时间
          <span style="color:#f7ba2a">30</span>分钟内未付款，会自动取消订单
        </div>
      </el-row>
      <div
        class="batch-operation ineffective-operation"
        style="float:right;top:5px"
        @click="removeData"
      >批量取消订单</div>
    </div>
    <div class="shopCar_table">
      <table class="shelves-table" v-if="orderList.length!=0" style="width:1040px">
        <thead>
          <tr>
            <th
              class="table-header-selectall th-blank-block"
              style="padding-left:0"
              :class="{'yigouxuan': isAllSelect}"
              @click="allSelect"
            >商品信息</th>
            <th>结算单价</th>
            <th>数量</th>
            <th>总额</th>
            <th>运费</th>
            <th>自有订单号</th>
          </tr>
        </thead>
        <tbody class="order-tbody" v-for="(item,index) in orderList" :key="index">
          <tr>
            <td colspan="7" class="self-tbody-space"></td>
          </tr>
          <tr>
            <td
              colspan="12"
              class="shelves-table-block-title blank-block"
              :class="{'yigouxuan': item.isSelect}"
              @click="selectItem(index)"
            >
              <!-- <td
                        class="shelves-table-item-select"

                        v-if="selectItem[index].shelvesProduct[index1].isSelect"
                        :class="{'yigouxuan': selectItem[index].shelvesProduct[index1].isChecked}"
              ></td>-->

              <span>订单编号：{{item.orderSn}}</span>
              <span>收件人：{{item.linkMan}}</span>
              <span>收货人电话：{{item.mobile}}</span>
              <span>{{item.address1}}</span>
            </td>
          </tr>
          <tr class="order-table-item" v-for="(detail, index) in item.orderDetailList" :key="index">
            <td class="order-table-image">
              <div class="order-table-image-wrap">
                <img :src="detail.imagePath" @error="error(1)" />
                <!-- <img :src="imgAddress + detail.navigateImg1" @error="error(1)"/> -->
              </div>
              <div>
                <div class="order-goods-name">{{detail.goodsName}}</div>
                <div
                  class="order-default-font order-guige"
                  style="color:#A2A2A2"
                >{{detail.specName}}</div>
                <div
                  class="order-default-font order-guige"
                  style="color:#A2A2A2"
                >SKU号：{{detail.productId}}</div>
                <div style="border: 1px solid rgb(103,191,135);width: 60px;text-align: center;color: rgb(64,173,104);background-color: rgb(240,255,246);font-size: 12px;display:block;" v-if="detail.isOwns > 0">自产自销</div>
              </div>
            </td>
            <td class="order-default-font">¥{{detail.cooperatePrice/100}}</td>
            <td class="order-default-font">{{detail.quantity}}</td>
            <td v-if="index == 0" :rowspan="item.orderDetailList.length" class="order-toDetail">
              <span style="display:block;color:#ffa726">{{item.totalCooperatePrice/100}}</span>
              <!-- <span style="display:block;color: #A2A2A2;margin-top:5px">(含运费:)</span> -->
              <!-- <div class="order-default-font" v-if="item.refund == 1">查看售后</div> -->
            </td>
            <td>￥{{item.freight/100}}</td>
            <td>{{detail.ownerOrderSn}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 确认订单-->
    <div class="certainButton" style="text-align:right" v-if="orderList.length!=0">
      <span class="spanClass">
        货款:
        <span style="color: #494949;">￥{{totalInfo.totalCooperatePrice/100}}</span>
      </span>
      <span class="spanClass">
        总运费:
        <span style="color: #494949;">￥{{totalInfo.totalFreight/100}}</span>
      </span>
      <span style="margin-right: 8px;margin-top: 13px;display: inline-block;">
        总计:
        <span class="priceColor" style="color: #494949;">￥{{totalInfo.total/100}}</span>
      </span>
      <span class="spanClass">
        可用余额:
        <span style="color: #494949;">￥{{totalInfo.lastMoney/100}}</span>
      </span>
      <el-button
        type="warning"
        size="small"
        @click="centainOrder"
        :disabled="disalbedFlag"
        style="width:170px;height:50px;border-radius: 0;font-size: 16px;"
      >确认订单</el-button>
      <div class="reminder export-tips" v-if="disalbedFlag">
        <span>可用余额不足</span>
      </div>
    </div>
    <!-- 分页效果 -->
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handlebinCurrentChange"
        :current-page.sync="pageNum"
        :total="total"
        :page-size="10"
        v-if="orderList.length!=0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  carGoToPay,
  carSettlementOrder,
  CarOrderNumberTotal,
  cancelPurchasingOrder
} from "../config/interface.js";
import { fetch, baseURL } from "../config/fetch.js";
import { toast } from "../util/tool.js";
import router from "../router/index.js";
export default {
  data() {
    return {
      isAllSelect: false,
      dislayFlag: true,
      index: 0,
      userId: this.$store.state.userId,
      appId: this.$store.state.appId,
      pageSize: 10,
      pageNum: 1,
      currentPage: 1,
      total: 0,
      disalbedFlag: false, //确认订单是否可以点击
      orderList: [], //表格渲染数据
      totalInfo: [], //订单结算价总额
      totalDetailNum: null, //商品行数量
      totalInfoNum: null //子订单
    };
  },
  mounted() {
    this.init();
    // this.orderNumber();
  },
  methods: {
    selectItem(i) {
      this.orderList[i].isSelect = !this.orderList[i].isSelect;
      console.log(this.orderList[i].isSelect);
      if (!this.orderList[i].isSelect) {
        this.isAllSelect = false;
      }
      this.$forceUpdate();
    },
    removeData() {
      this.$confirm("确定要取消所选订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning"
      })
        .then(() => {
          let ids = [];
          for (let i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].isSelect) {
              ids.push(this.orderList[i].orderDetailList[0].orderInfoId);
            }
          }

          let params = {
            appId: this.appId,
            ids,
            userId: this.userId
          };
          fetch(cancelPurchasingOrder, params).then(res => {
            setTimeout(() => {
              this.init();
            }, 500);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    allSelect() {
      if (!this.isAllSelect) {
        this.isAllSelect = true;
        for (let i = 0; i < this.orderList.length; i++) {
          this.orderList[i].isSelect = true;
        }
      } else {
        this.isAllSelect = false;
        for (let i = 0; i < this.orderList.length; i++) {
          this.orderList[i].isSelect = false;
        }
      }
    },
    init() {
      let url = carGoToPay;
      let params = {
        appId: this.appId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userId: this.userId
      };
      fetch(url, params).then(res => {
        console.log("未付款订单");
        console.log(res);
        if (res.code == 10000) {
          res.data.resultOrder.forEach((value, index) => {
            //  对地址进行的拼接
            value.address1 =
              value.province + value.city + value.area + value.address;
          });
          this.orderList = res.data.resultOrder;
          for (let i = 0; i < this.orderList.length; i++) {
            this.orderList[i].isSelect = false;
          }
          this.total = res.data.totalInfo.count;
          // 总结算价
          this.totalInfo = res.data.totalInfo;
          let supMoney = this.totalInfo.lastMoney;
          let totalMoney = this.totalInfo.total;
          if (totalMoney > supMoney) {
            this.disalbedFlag = true;
            return;
          }
          //  如果订单列表为空返回采购车页面
          if (this.orderList.length == 0) {
            this.$emit("switchPage", "1");
            toast("暂无可确认的订单", 3, false);
          }
          this.orderNumber();
        }
      });
    },
    // 订单小结
    orderNumber() {
      let url = CarOrderNumberTotal;
      let params = {
        appId: this.appId,
        userId: this.userId
      };
      fetch(url, params).then(res => {
        console.log("订单总数显示");
        console.log(res);
        this.totalDetailNum = res.data.totalDetailNum;
        this.totalInfoNum = res.data.totalInfoNum;
      });
    },
    centainOrder() {
      let supMoney = this.totalInfo.lastMoney;
      let totalMoney = this.totalInfo.totalCooperatePrice;
      if (totalMoney > supMoney) {
        this.disalbedFlag = true;
        return;
      }
      let url = carSettlementOrder;
      let params = {
        appId: this.appId,
        userId: this.userId
      };
      console.log("确认订单");
      console.log(params);
      fetch(url, params).then(res => {
        console.log(res);
        if (res.code == 10000) {
          //  清空订单列表
          this.orderList = [];
          this.dislayFlag = false;
          this.settlementDialog();
        } else {
          if (res.code == 20100) {
            router.replace({
              path: "/"
            });
          } else {
            toast(res.message, 2, false);
          }
        }
      });
    },
    settlementDialog() {
      const h = this.$createElement;
      this.$msgbox({
        message: h("div", null, [
          h("img", null, " "),
          h("span", null, "下单成功")
        ]),
        showCancelButton: true,
        // 确定按钮
        confirmButtonText: "回到采购车",
        cancelButtonText: "查看订单",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            this.$emit("switchPage", "1");
          } else {
            done();
            // router.replace({
            //     path: '/manage/order'
            // });
            router.push({
              path: "/manage/order"
            });
          }
        }
      });
    },
    // 改变当前页
    handlebinCurrentChange(val) {
      this.pageNum = val;
      this.init();
    }
  }
};
</script>

<style>
.th-blank-block::before {
  content: "全选";
  margin-left: 50px;
  float: left;
}

.blank-block {
  padding-left: 42px;
  padding-right: 15px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR…L8aJCSHGSENIwGKaEQIll++AcpvF0KazeSHEYkaqB7kAIAuuoJVDzmJJ8AAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-size: 14px;
  background-position: 15px;
  height: 50px;
  background-color: #f8f8f7;
  cursor: pointer;
}

.spanClass {
  display: inline-block;
  margin-right: 20px;
  color: #a2a2a2;
  font-size: 14px;
}

.priceColor {
  color: rgb(255, 167, 38);
}

.export-tips {
  color: red;
  font-size: 12px;
  position: relative;
}

.export-tips span {
  position: absolute;
  right: 15px;
  top: 13px;
}

.el-message-box__message {
  /* position: relative; */
}

.el-message-box__message > div > img {
  width: 100px;
  height: 100px;
  /* border: 1px solid red; */
  margin-left: 100px;
  border-radius: 50px;
  background: url("../assets/img/gou.png") no-repeat;
  background-size: 100% 100%;
}

.el-message-box__message > div > span {
  display: block;
  text-align: center;
  font-size: 16px;
  /* margin-top: 5px; */
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// shopCarGoOrder.vue?713a7b80